import axios from "@/config/httpConfig";
//获取域名
export function geturl(data) {
    return axios.post('/report/getExportReportURL', data)
}